import {
  Box,
  // IconButton
} from '@material-ui/core';

// import { Icon, Typography } from '@components';

import { LibrariesPanelWrapperProps } from './LibrariesPanelWrapper.props';
import { useStyles } from './LibrariesPanelWrapper.styles';
import { LibraryPanel } from '../LibraryPanel';
// import { content } from '@content';

/**
 LibrariesPanelWrapper component
 @returns {JSX.Element}
 */

export const LibrariesPanelWrapper = ({
  children,
  className,
  isImageLibrary = false,
  onChooseLibrary,
}: LibrariesPanelWrapperProps): JSX.Element => {
  const styles = useStyles();

  return (
    <Box
      className={`${styles.librariesPanelWrapper} ${!isImageLibrary ? styles.moduleLibrariesPanelWrapper : ''} ${className ? className : ''}`}
      style={{ width: isImageLibrary ? '43rem' : '45rem' }}
    >
      {!isImageLibrary && <LibraryPanel onChooseLibrary={onChooseLibrary} />}
      <Box className={`${styles.content} ${!isImageLibrary ? styles.notImageLibrary : ''}`}>{children}</Box>
    </Box>
  );
};
